export default "__VITE_ASSET__f45f140f__"